export default __webpack_public_path__ + "15b58a8a2767775133fc8a47a3428c0e.png";